import {
  Box,
  DatePickerC,
  Grid,
  NumberFieldC,
  SelectC,
  TextFieldC
} from 'components'
import { useLoadOrderFreights } from 'modules/orders/hooks'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { DirtRoadForm } from '../../dirtRoadForm'
import { SelectDeliveryAddressCompany } from '../../SelectDeliveryAddressCompany'
import { RecalculeAlert } from '../../recalculeAlert'

export default function Freight() {
  const { watch, setValue } = useFormContext()
  const [hideFreightPrice, setHideFreightPrice] = useState(false)

  // const form = useOrderStore.useForm()

  // const freightPrice = watch('freightPrice')
  const freightType = watch('freightType')

  const { data, isLoading } = useLoadOrderFreights({})
  // const { data: freightSuggestion, isLoading: isFreightSuggestionLoading } =
  //   useLoadOrderFreightSuggestion({
  //     customerId: watch('customer')?.id,
  //     products: form?.orderItems.map((item: any) => item.product.id),
  //     totalOrder: form?.total?.totalItems,
  //     unityId: watch('unity')?.id
  //   })

  // const isFreightSuggestion = 0
  // Number(freightSuggestion?.freightValue) === Number(freightPrice)

  useEffect(() => {
    if (freightType?.id === '1') {
      setHideFreightPrice(false)
    } else {
      setValue('freightPrice', 0)
      setHideFreightPrice(true)
    }
  }, [freightType, setValue])

  // useEffect(() => {
  //   if (!String(freightPrice) && freightType?.id === '1') {
  //     setValue('freightPrice', freightSuggestion?.freightValue)
  //   }
  // }, [freightPrice, freightSuggestion, setValue, freightType?.id])

  return (
    <Box
      style={{
        width: '100%',
        padding: 12
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RecalculeAlert />
        </Grid>

        <Grid item xs={12}>
          <SelectC
            name="freightType"
            options={data?.data}
            label="Tipo de Frete"
            loading={isLoading}
            getOptionLabel={(option: any) => option?.name}
          />
        </Grid>
        {!hideFreightPrice && (
          <>
            <Grid item xs={12}>
              <NumberFieldC name="freightPrice" label="Frete" prefix="R$ " />
            </Grid>

            {/* <Grid item xs={12}>
              {!isFreightSuggestion && (
                <Alert severity="warning">
                  Frete Sugerido (
                  {formatCurrency(freightSuggestion?.freightValue)}) está
                  diferente do frete atual!
                </Alert>
              )}
            </Grid> */}
          </>
        )}
        {watch('orderType')?.id === 'V' && (
          <Grid item xs={12}>
            <SelectDeliveryAddressCompany />
          </Grid>
        )}

        <Grid item xs={12}>
          <DatePickerC
            name="deliveryDate"
            // minDate={minDate}
            label={`Previsão de Entrega`}
            inputFormat="dd/MM/yyyy"
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerC
            name="requestedDate"
            label="Data Desejada"
            inputFormat="dd/MM/yyyy"
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldC
            name="expeditionObs"
            label="Observação de Entrega"
            multiline
            rows={3}
          />
        </Grid>
        <Grid item xs={12}>
          <DirtRoadForm />
        </Grid>
      </Grid>
    </Box>
  )
}
